// extracted by mini-css-extract-plugin
export default {"content":"content_content__SiVLs","textWrap":"content_textWrap__1LQdr"};